export const shadows = {
    layout: "0 1px 6px 0 rgba(0, 0, 0, .21)",
    small: "0 0 4px 0 rgba(0, 0, 0, .25)",
    medium: "0 0 6px 0 rgba(0, 0, 0, .43)",
    big: "0 0 6px 0 rgba(0, 0, 0, .5)",
};
